import { HomePage } from '../pages/HomePage';
import { ServicesPage } from '../pages/ServicesPage';
import { AboutPage } from '../pages/AboutPage';
import { CasesPage } from '../pages/CasesPage';
import { ContactPage } from '../pages/ContactPage';
import { NotFoundPage } from '../pages/NotFoundPage';
import { Typography } from '../components/Typography';
export function App({ path = '/' }: { path?: string }) {
  const normalized = path === '/' ? '/' : `${path.replace(/\/+$/, '')}/`;
  const Page =
    (
      {
        '/': HomePage,
        '/services/': ServicesPage,
        '/about/': AboutPage,
        '/cases/': CasesPage,
        '/contact/': ContactPage,
      } as Record<string, typeof HomePage>
    )[normalized] ?? NotFoundPage;
  return (
    <>
      <a href="#main-content" className="skip-link">
        <Typography as="span">Перейти к содержимому</Typography>
      </a>
      <main id="main-content">
        <Page />
      </main>
    </>
  );
}
